const getSeriesQuestionSlug = (series: string, index: string | number, question: string) =>
    `${series}.${index}.${question}`;

export default getSeriesQuestionSlug;
